import { PropTypes } from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { hideDialog } from '../actions';
import ModalDialog from './Modal';

const ConfirmDialog = ({
  closeDialog,
  isOpen,
  title,
  text,
  onReady,
  onReadyParams,
  className,
  submitButtonText,
  cancelButtonText,
  onCancel,
  showSubmitLoader,
}) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const isMountedRef = useRef(false);

  useEffect(() => {
    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
    };
  }, []);

  const handleReady = () => {
    setIsSubmitting(true);
    return Promise.resolve(onReady()).finally(() => {
      if (isMountedRef.current) {
        setIsSubmitting(false);
      }
    });
  };

  return (
    <ModalDialog
      title={title}
      onReady={showSubmitLoader ? handleReady : onReady}
      onReadyParams={onReadyParams}
      isOpen={isOpen}
      close={closeDialog}
      className={className}
      submitButtonText={submitButtonText}
      cancelButtonText={cancelButtonText}
      onCancel={onCancel}
      isSubmitting={showSubmitLoader && isSubmitting}
    >
      {text}
    </ModalDialog>
  );
};

ConfirmDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  className: PropTypes.string,
  closeDialog: PropTypes.func.isRequired,
  onReady: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  onReadyParams: PropTypes.shape({}),
  submitButtonText: PropTypes.string,
  cancelButtonText: PropTypes.string,
  onCancel: PropTypes.func,
  showSubmitLoader: PropTypes.bool,
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({ closeDialog: hideDialog }, dispatch);
};

export default connect(null, mapDispatchToProps)(ConfirmDialog);
